export const SET_AUTH_TOKEN = "SET_AUTH_TOKEN";
export const REMOVE_AUTH_TOKEN = "REMOVE_AUTH_TOKEN";
export const AUTH_LOADING = "AUTH_LOADING";

export const SET_CHAT_USER = 'SET_CHAT_USER'
export const SET_ROOMS = 'SET_ROOMS'

export const ADD_PROFILE = "ADD_PROFILE"
export const REMOVE_PROFILE = "REMOVE_PROFILE"

export const SET_FEED_LOADER = "SET_FEED_LOADER"
export const SET_VIDEOS = "SET_VIDEOS"
export const SET_POSTS = "SET_POSTS"
export const SET_POLLS = "SET_POLLS"
export const SET_QNAS = "SET_QNAS"
export const SET_SEARCH_FIELD = "SET_SEARCH_FIELD"
export const SET_ACTIVE_FILTER = "SET_ACTIVE_FILTER"
export const SET_FILTERED_CONTENT = "SET_FILTERED_CONTENT"
export const SET_FILTERED_VIDEOS = "SET_FILTERED_/VIDEOS"
export const SET_ALL_CONTENT = "SET_ALL_CONTENT"
export const SET_CONTENT_BY_SLUG = "SET_CONTENT_BY_SLUG"
export const SET_LEADERBOARD = "SET_LEADERBOARD"
export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS"
export const SET_UNSEEN_NOTIFICATIONS_COUNT = "SET_UNSEEN_NOTIFICATIONS_COUNT"
export const SET_SOCKET_CONNECTION = "SET_SOCKET_CONNECTION"
export const SET_INTERESTS_OPEN = "SET_INTERESTS_OPEN"
export const POSTS = "POSTS"
export const QNAS = "QNAS"
export const VIDEOS = "VIDEOS"
export const POLLS = "POLLS"
export const ALL = "ALL"

//sourcing bot
export const SET_ACTIVE_SEARCH_COMBO_INDEX = "SET_ACTIVE_SEARCH_COMBO_INDEX";